import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=4f730e7b&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f730e7b')) {
      api.createRecord('4f730e7b', component.options)
    } else {
      api.reload('4f730e7b', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=4f730e7b&", function () {
      api.rerender('4f730e7b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2drp50WKJzEMO/JS/offershelp.vue"
export default component.exports